"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputControls = void 0;
// external
const React = require("react");
// local
const CircularIcon_1 = require("../CircularIcon");
const Collapse_1 = require("../Collapse");
const Message_1 = require("../Message");
const colors_1 = require("../../../../types/colors");
// css
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "InputControls");
const InputControls = ({ onClearValue = false, errors = [], children, indentClear }) => {
    const error = Array.isArray(errors) && errors.length ? errors[0] : null;
    const clearFunc = typeof onClearValue === "function" ? onClearValue : () => { };
    return (React.createElement("div", null,
        React.createElement("div", { className: css("", {
                "-clearable": !!onClearValue,
                "-indentClear": indentClear
            }) },
            React.createElement("div", { className: css("input") },
                children,
                React.createElement("span", { className: css("clear", { "-active": !!onClearValue }), "data-test": "clear", "data-test-active": !!onClearValue ? "active" : "inactive" },
                    React.createElement(CircularIcon_1.CircularIcon, { name: "cancel", variant: colors_1.TColorVariants.Secondary, disabled: !onClearValue, onClick: clearFunc })))),
        React.createElement("div", { "data-test": "errors" },
            React.createElement(Collapse_1.Collapse, { isOpened: !!error },
                React.createElement("div", { "data-test": "error" },
                    React.createElement(Message_1.ErrorMessage, null,
                        React.createElement(Message_1.MessageBody, null, error)))))));
};
exports.InputControls = InputControls;
//# sourceMappingURL=index.js.map